import { Dispatch, useMemo, useState } from "react";

import "@/components/dialog/dialog.css";
import {
  ModelMapParameterMapLayerConfiguration,
  ParametersModeledMapLayer,
} from "@/lib/api";
import {
  PickListItem,
  PickListModal,
} from "@/features/widget-forms/forms/weather-model-map/modals/pick-list-modal";
import {
  ConfigureLayerModal,
  LayerDetails,
} from "@/features/widget-forms/forms/map-widget-editor/configure-layer-modal";
import { fmtSubtitle } from "@/features/widget-forms/forms/weather-model-map/modals/map-layer-formatters";
import { useTranslation } from "@/lib/i18n";

interface AddMapLayerModalProps {
  mapLayers: ParametersModeledMapLayer[];
  selectedMapLayerIds: string[];
  onAddMapLayer: Dispatch<ModelMapParameterMapLayerConfiguration>;
  selectedModelName?: string;
}

const AddMapLayerModal = ({
  mapLayers,
  selectedMapLayerIds,
  onAddMapLayer,
  selectedModelName,
}: AddMapLayerModalProps) => {
  const { t } = useTranslation();
  const items = useMemo(
    () =>
      mapLayers.map((layer): PickListItem => ({
        id: layer.id,
        title: layer.label,
        subtitle: fmtSubtitle(layer.zoom_levels),
      })),
    [mapLayers],
  );

  const [configurationVisible, setConfigurationVisible] = useState<boolean>(false);
  const [mapLayerId, setMapLayerId] = useState<string>();

  const onPick = (mapLayerId: string) => {
    setConfigurationVisible(true);
    setMapLayerId(mapLayerId);
  };
  const mapLayer = mapLayers.find((layer) => layer.id === mapLayerId);

  function onSubmitConfiguration(details: LayerDetails) {
    if (!mapLayerId) return;
    onAddMapLayer({
      parameter_map_layer_id: mapLayerId,
      label: details.label,
    });
    setConfigurationVisible(false);
  }

  return (
    <>
      <PickListModal
        title={t("admin.widgets.fields.model_map.map_layers.add")}
        description={t("admin.widgets.fields.model_map.map_layers.add_description", {
          model: selectedModelName,
        })}
        addText={t("admin.widgets.fields.model_map.map_layers.add")}
        emptyText={t("admin.widgets.fields.model_map.map_layers.no_layers_available")}
        items={items}
        selected={selectedMapLayerIds}
        onPick={onPick}
      />
      <ConfigureLayerModal
        layer={mapLayer}
        open={configurationVisible}
        onSubmit={onSubmitConfiguration}
        onCancel={() => setConfigurationVisible(false)}
      />
    </>
  );
};

export default AddMapLayerModal;
